import React from 'react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';

class DateInput extends SemanticDatepicker {
	static defaultProps = {
		...SemanticDatepicker.defaultProps,
		format: 'MM/DD/YYYY'
	}
}

export default DateInput;